import { render, staticRenderFns } from "./ClaimFormStep.vue?vue&type=template&id=4ab06686&scoped=true"
import script from "./ClaimFormStep.vue?vue&type=script&lang=js"
export * from "./ClaimFormStep.vue?vue&type=script&lang=js"
import style0 from "./ClaimFormStep.vue?vue&type=style&index=0&id=4ab06686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab06686",
  null
  
)

export default component.exports